import { render, staticRenderFns } from "./mailbox.vue?vue&type=template&id=4fadff6e&"
import script from "./mailbox.vue?vue&type=script&lang=js&"
export * from "./mailbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports